import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import style from './PageSubtitle.module.scss'

const PageSubtitle = ({ text }) => {
  const { color, colabelNeutralDark } = useContext(ClientContext)

  return <p className={style['page-subtitle']} style={ color && { color: colabelNeutralDark }}>{text}</p>
}

export default PageSubtitle
